import React from 'react'
import { formatMonto } from '../../common/dashboard-utils'
import BotonExportar from '../dashboard-comunes/boton-exportar'

/**
 * Estado Evaluación CIA — **V1.1 (RG-541, 04-09-2026)**.
 *
 * 🔴 Cambió el agrupamiento y las claves: ahora la fila viene agrupada por
 *    `aci_int_motivoRespuesta` traducido con `concepto_detalle.cde_var_glosa`, y llega como
 *    `{ motivoId, motivo, cantidad, montoTotal }` — antes era
 *    `{ estadoEvaluacion, cantidad, montoPagoTotal }`, derivado de `respuesta_recdef_externo`.
 * 🔴 El orden pasa a ser por CANTIDAD de casos, no por monto.
 */

const COLORES = {
    'A pago mes en curso': '#28a745',
    'Versiones Controvertidas': '#fd7e14',
    'Sin motivo': '#6c757d',
    'Falta pago deducible del Asegurado': '#dc3545',
    'Bajo Deducible': '#ffc107',
    'No Coincide Dinámica': '#007bff',
    'Involucra Cambio de Pista': '#17a2b8',
    'A pago próximo mes': '#20c997',
    'Pendiente de correlativo RC': '#6f42c1',
    'Involucra Semáforo': '#e83e8c',
    'Sólo Daños Traseros': '#343a40',
    'Faltan Antecedentes': '#6610f2'
}
const COLOR_FALLBACK = '#adb5bd'

// Con `onExportar(fila)`, cada fila lleva el ícono Excel que descarga sus casos (RG-602).
const EstEvalTabla = ({ data = [], onExportar }) => {
    if (!data.length) return <div className='text-center text-muted py-5'>Sin datos</div>

    const total = data.reduce((acc, d) => acc + d.cantidad, 0)
    const totalMonto = data.reduce((acc, d) => acc + (d.montoTotal || 0), 0)
    const maxCantidad = Math.max(...data.map((d) => d.cantidad))
    const ordenadas = [...data].sort((a, b) => b.cantidad - a.cantidad)

    return (
        <div style={{ overflowY: 'auto', maxHeight: 290 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
                <thead>
                    <tr style={{ borderBottom: '2px solid #dee2e6', position: 'sticky', top: 0, zIndex: 1 }}>
                        <th style={{ padding: '7px 10px', background: '#f8f9fa', fontWeight: 600 }}>Motivo Respuesta</th>
                        <th style={{ padding: '7px 10px', background: '#f8f9fa', fontWeight: 600, textAlign: 'right' }}>Casos</th>
                        <th style={{ padding: '7px 10px', background: '#f8f9fa', fontWeight: 600, minWidth: 110 }}>Distribución</th>
                        <th style={{ padding: '7px 10px', background: '#f8f9fa', fontWeight: 600, textAlign: 'right', whiteSpace: 'nowrap' }}>Monto Total</th>
                        {onExportar && <th style={{ padding: '7px 10px', background: '#f8f9fa', width: 36 }} />}
                    </tr>
                </thead>
                <tbody>
                    {ordenadas.map((row) => {
                        const porcentaje = total ? Math.round(row.cantidad / total * 100) : 0
                        const anchoBarra = maxCantidad ? Math.round(row.cantidad / maxCantidad * 100) : 0
                        const color = COLORES[row.motivo] || COLOR_FALLBACK
                        return (
                            <tr key={row.motivoId || row.motivo} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                <td style={{ padding: '5px 10px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                                        <span style={{ flexShrink: 0, width: 10, height: 10, borderRadius: '50%', background: color, display: 'inline-block' }} />
                                        {row.motivo}
                                    </div>
                                </td>
                                <td style={{ padding: '5px 10px', textAlign: 'right', fontWeight: 600 }}>{row.cantidad}</td>
                                <td style={{ padding: '5px 10px' }}>
                                    <div style={{ background: '#e9ecef', borderRadius: 3, height: 10, marginBottom: 2 }}>
                                        <div style={{ background: color, width: `${anchoBarra}%`, height: '100%', borderRadius: 3 }} />
                                    </div>
                                    <span style={{ fontSize: 10, color: '#6c757d' }}>{porcentaje}%</span>
                                </td>
                                <td style={{ padding: '5px 10px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                                    {row.montoTotal ? formatMonto(row.montoTotal) : '—'}
                                </td>
                                {onExportar && (
                                    <td style={{ padding: '5px 10px', textAlign: 'center' }}>
                                        <BotonExportar
                                            size={14}
                                            titulo={`Descargar los casos de "${row.motivo}" en Excel`}
                                            onClick={() => onExportar(row)}
                                        />
                                    </td>
                                )}
                            </tr>
                        )
                    })}
                </tbody>
                <tfoot>
                    <tr style={{ borderTop: '2px solid #dee2e6', background: '#f8f9fa' }}>
                        <td style={{ padding: '6px 10px', fontWeight: 700 }}>Total</td>
                        <td style={{ padding: '6px 10px', textAlign: 'right', fontWeight: 700 }}>{total}</td>
                        <td />
                        <td style={{ padding: '6px 10px', textAlign: 'right', fontWeight: 700, whiteSpace: 'nowrap' }}>{formatMonto(totalMonto)}</td>
                        {onExportar && <td />}
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

export default EstEvalTabla
